import template from './coworking-price.jade';
import coworkingPriceList from '../../../enums/coworking-price-list';
import possibleItems from '../../../enums/included-options';
import { numberToPrettyString } from '@cian/utils';
import validation from '../../../services/validation';
import './coworking-price.css';

export default angular
  .module('cian.addForm.coworkingPrice', [])
  .directive('cianAfAboutObjectCoworkingPrice', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      priceLimit: '@?',
    },
    controller: [
      '$scope',
      'deviceService',
      'coworkingService',
      function (
        $scope,
        deviceService,
        coworkingService,
      ) {
        this.isMobile = deviceService.isMobile;
        this.isFlexOffice = coworkingService.isFlexOffice();
        this.priceLabel = this.isFlexOffice ? 'Цена' : 'Цена за рабочее место';

        this.tooltipText = '';
        this.ad.bargainTerms = this.ad.bargainTerms || {};
        this.ad.bargainTerms.paymentPeriod = 'monthly';
        this.ad.bargainTerms.currency = 'rur';
        this.ad.bargainTerms.priceType = 'all';
        this.ad.bargainTerms.vatIncluded = true;
        this.ad.bargainTerms.vatType = 'included';
        this.valueMin = 0;
        this.valueMax = this.priceLimit ? Number(this.priceLimit) : 10e9;
        this.inputPattern = angular.isDefined(this.allowZero)
          ? /^\d+/
          : /^[1-9]{1}[0-9]{0,}/;

        this.priceList = coworkingPriceList;
        this.priceType = (this.ad.bargainTerms.priceForWorkplace || !this.isFlexOffice)
          ? 'priceForWorkplace'
          : 'all';

        if (this.priceType === 'priceForWorkplace') {
          this.price = this.ad.bargainTerms.priceForWorkplace;
        } else if (this.priceType === 'all') {
          this.price = this.ad.bargainTerms.price;
        }

        this.ad.bargainTerms.includedOptions =
          this.ad.bargainTerms.includedOptions || [];
        this.items = possibleItems.map(item => ({
          ...item,
          checked:
            this.ad.bargainTerms.includedOptions.indexOf(item.value) !== -1,
        }));

        const refreshBargainTerms = (price, workplaceCount) => {
          const newPriceForAll = Number((price * workplaceCount).toFixed(0));
          const newPriceForWorkplace = Number((price / workplaceCount).toFixed(0));

          if (this.priceType === 'priceForWorkplace') {
            this.ad.bargainTerms.priceForWorkplace = price;
            this.ad.bargainTerms.price = newPriceForAll;

            return newPriceForAll;
          }

          if (this.priceType === 'all') {
            this.ad.bargainTerms.price = price;
            this.ad.bargainTerms.priceForWorkplace = undefined;

            return newPriceForWorkplace;
          }
        };

        this.onChangePriceType = () => {
          if (!this.ad.workplaceCount) {
            return;
          }

          refreshBargainTerms(this.price, this.ad.workplaceCount);
        };

        this.getPriceDesc = () => {
          let priceLabel = 'в мес.';

          if (this.ad.workplaceCount <= 0 || !this.price || this.ad.coworkingOfferType !== 'office') {
            return priceLabel;
          }

          const price = refreshBargainTerms(this.price, this.ad.workplaceCount);
          const formattedPrice = numberToPrettyString(price);

          if (this.priceType === 'priceForWorkplace') {
            priceLabel += `, ${formattedPrice} ₽/мес. за весь офис`;
          }

          if (this.priceType === 'all') {
            priceLabel += `, ${formattedPrice} ₽/мес. за рабочее место`;
          }

          return priceLabel;
        };

        $scope.$watchGroup([
          () => this.price,
          () => this.ad.workplaceCount,
        ],
          ([newPrice, workplaceCount]) => {
            const nextPrice = Number(newPrice);
            if (!newPrice || newPrice <= 0 || !workplaceCount || workplaceCount <= 0) return;

            if (!this.isFlexOffice) {
              this.ad.bargainTerms.priceForWorkplace = nextPrice;
              this.ad.bargainTerms.price = nextPrice * workplaceCount;
              return;
            }

            refreshBargainTerms(newPrice, workplaceCount);
          },
          true
        );

        $scope.$watch(
          () => this.items,
          newItems => {
            if (!newItems) return;
            this.ad.bargainTerms.includedOptions = newItems
              .map(item => (item.checked ? item.value : undefined))
              .filter(Boolean);
          },
          true
        );

        this.validation = validation(this, 'price', {
          parse: 'Введите число',
          required: 'Не указана стоимость',
          min: 'Цена должна быть больше 0',
          max: 'Допустимо не более 10 символов',
        });
      },
    ],
    controllerAs: 'ctrl',
    template,
  })).name;
